let blocks = []
const requireModule = require.context('@/configurations/procedures/blocks', true, /\.js$/i, 'sync')
requireModule.keys()
  .filter(fileName => fileName !== './index.js')
  .forEach(fileName => {
    blocks = [...blocks, ...[requireModule(fileName).default]]
  })

export default blocks
